export default {
  modoFacturacion: [
    {
      text: 'Dejar sin especificar',
      value: null
    },
    {
      text: 'Facturar todos los restaurantes al negocio',
      value: 'negocio'
    },
    {
      text: 'Facturar a cada restaurante independiente',
      value: 'restauranteIndividual'
    },
  ],
  modoFacturacionDirectorio: [
    {
      text: 'Dejar sin especificar',
      value: null
    },
    {
      text: 'Facturar al directorio',
      value: 'directorio'
    },
    {
      text: 'Facturar al siguiete negocio',
      value: 'directorioNegocio'
    },
  ],
  overlayPedidos: false,
  datosFacturacionNegocioGest: null,
  negocioFacturando: null,
  facturasArray: [],
  rangoFacturando: [null, null],
  startAt: 0, //para paginar
  pedidosRango: [],
  cabeceraTexto: ['#', 'Fecha', 'Modo', 'Pago', 'Cantidad', '% Online', 'Fijo Online', '% Pedido', 'Fijo Pedido', 'Total Tasa'], //para pdf y tablas
  estadoFacturas: ['generada', 'generada_auto', 'archivada', 'Enviada email'], //Enviada email depreciar
  estadoFiltrando: 'generada',
  formasCobroFactura: [
    {
      text: 'CUENTA CONECTADA',
      value: 'conectada'
    }
  ],
  search: ''
}